/**
 * Boot-time purge of legacy/dev-only localStorage keys and stray event
 * listeners so a stale browser cannot re-enable any debug UI after refresh.
 *
 * Idempotent and safe to import unconditionally — runs once at module load.
 */

const LEGACY_LOCALSTORAGE_KEYS = [
  "dev:heroOverlayOverride",
  "dev:heroOverlayOverride:open",
  "dev:forceDevTools",
  "dev:debugOverlay",
  "dev:debugToolbar",
];

const LEGACY_CUSTOM_EVENTS = [
  "hero-overlay-override-change",
];

const purgeDevState = () => {
  if (typeof window === "undefined") return;

  // 1. Wipe known dev-only localStorage keys.
  try {
    for (const key of LEGACY_LOCALSTORAGE_KEYS) {
      window.localStorage.removeItem(key);
    }
    // Belt-and-braces: remove anything else under the `dev:` namespace.
    for (let i = window.localStorage.length - 1; i >= 0; i--) {
      const k = window.localStorage.key(i);
      if (k && k.startsWith("dev:")) window.localStorage.removeItem(k);
    }
  } catch {
    /* private mode / disabled storage — ignore */
  }

  // 2. Same for sessionStorage, in case anything was mirrored there.
  try {
    for (const key of LEGACY_LOCALSTORAGE_KEYS) {
      window.sessionStorage.removeItem(key);
    }
  } catch {
    /* ignore */
  }

  // 3. Neutralise any lingering custom-event dispatchers by overriding the
  //    target with a no-op handler at the window level. Real listeners are
  //    gone in code, but this stops bookmarklets / extensions from firing them.
  for (const evt of LEGACY_CUSTOM_EVENTS) {
    try {
      window.addEventListener(evt, (e) => e.stopImmediatePropagation(), true);
    } catch {
      /* ignore */
    }
  }
};

purgeDevState();

export {};
